module.exports = __webpack_public_path__ + "img/icon_2_50.e23a675c.png";